import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M13.16,15.88H8.91a5.5,5.5,0,0,0-5.5,5.5H1.91v-5a7,7,0,0,1,7-7h4.25V7.7a2,2,0,0,1,1.27-1.86,2,2,0,0,1,2.2.5l4.55,4.93a2,2,0,0,1,0,2.71l-4.55,4.93a2,2,0,0,1-3.47-1.36Zm-9.75,5.5a.75.75,0,0,1-1.5,0Zm5.5-7h5a.74.74,0,0,1,.75.74v2.43a.5.5,0,0,0,.87.34L20.08,13a.5.5,0,0,0,0-.67L15.52,7.36A.49.49,0,0,0,15,7.23a.51.51,0,0,0-.32.47v2.42a.75.75,0,0,1-.75.76h-5a5.5,5.5,0,0,0-5.5,5.5V17A7,7,0,0,1,8.91,14.38Z' />
  </svg>
);
